/**
 * Avalara © 2019
 * file: engines/opus_ui/src/utils/objectCompare.js
 */

// This is a deep compare of 2 objects. it checks if objects are equal or if the seconds object is a superset of the first object.
// Example the firstobject could be called OldApiCallResult.
// and the 2nd object called cashedAPIresulsts witch should be a idenical to the first object but with an extra field called wasThereACacheHit.
// I could not get  lodash's  _.isEqual(res1, res2) to work
export function objectCompare(obj1, obj2, label = '', diffCollection = []) {
  //try catch block is cheap way of checking for things like it obj1 is an object but obj2 is a string or an array
  try {
    if (obj1 && typeof obj1 === 'object') {
      //If we wanted to modify this for a true compare we could check if obj2 has keys that are not in obj1
      Object.keys(obj1).forEach(
        (key) =>
          (diffCollection = objectCompare(
            obj1[key],
            obj2[key],
            `${label}.${key}`,
            diffCollection
          ))
      );
      return diffCollection;
    }
    if (Array.isArray(obj1)) {
      if (obj1.length !== obj2.length) {
        diffCollection.push(
          `on ${label.substr(1)} obj1 has ${obj1.length} items and obj2 has ${
            obj2.length
          } items`
        );
      } else {
        for (let i = 0; i < obj1.length; i++) {
          diffCollection = objectCompare(
            obj1[i],
            obj2[i],
            `${label}.[${i}]`,
            diffCollection
          );
        }
      }
      return diffCollection;
    }
    //console.log(label)
    if (obj1 !== obj2) {
      diffCollection.push(
        `on ${label.substr(1)} obj1 was "${obj1}" and obj2 was "${obj2}"`
      );
    }
    return diffCollection;
  } catch (error) {
    diffCollection.push(
      `on ${label.substr(1)} obj1 was "${obj1}" and obj2 was "${obj2}"`
    );
    return diffCollection;
  }
}
